import React, { Fragment } from 'react';
import { AkFormFooter, AkForm, useForm } from '../form';
import { AkButton, ButtonSet } from '../button';
function Form(props) {
  var _useForm = useForm(props),
    actions = _useForm.actions,
    akFormProps = _useForm.akFormProps,
    akSubmitButtonProps = _useForm.akSubmitButtonProps,
    children = _useForm.children,
    htmlFormProps = _useForm.htmlFormProps;
  var key = akFormProps.key,
    onSubmit = akFormProps.onSubmit;
  var submitButtonChildren = akSubmitButtonProps.children,
    shouldFitContainer = akSubmitButtonProps.shouldFitContainer,
    iconBefore = akSubmitButtonProps.iconBefore,
    iconAfter = akSubmitButtonProps.iconAfter,
    loading = akSubmitButtonProps.isLoading,
    disabled = akSubmitButtonProps.isDisabled,
    onClick = akSubmitButtonProps.onClick,
    type = akSubmitButtonProps.type;
  // @ts-ignore Ignoring the fact that "data-testid" is not part of the declared type
  var className = htmlFormProps.className,
    dataTestId = htmlFormProps['data-testid'];
  return /*#__PURE__*/React.createElement(AkForm, {
    key: key,
    onSubmit: onSubmit
  }, function (_ref) {
    var formProps = _ref.formProps;
    var onSubmit = formProps.onSubmit,
      onKeyDown = formProps.onKeyDown,
      ref = formProps.ref;
    return /*#__PURE__*/React.createElement("form", {
      onSubmit: onSubmit,
      onKeyDown: onKeyDown,
      ref: ref
      // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
      ,
      className: className,
      "data-testid": dataTestId
    }, children, /*#__PURE__*/React.createElement(AkFormFooter, {
      align: "end"
    }, /*#__PURE__*/React.createElement(ButtonSet, null, actions, /*#__PURE__*/React.createElement(AkButton, {
      shouldFitContainer: shouldFitContainer,
      iconBefore: iconBefore,
      iconAfter: iconAfter,
      isLoading: loading,
      isDisabled: disabled,
      onClick: onClick,
      type: type,
      appearance: "primary"
    }, submitButtonChildren))));
  });
}
export function getInlineDialog(_ref2) {
  var forgeDoc = _ref2.forgeDoc,
    dispatch = _ref2.dispatch,
    render = _ref2.render;
  return {
    children: forgeDoc.children[0].type === 'Form' ? /*#__PURE__*/React.createElement(Form, {
      forgeDoc: forgeDoc.children[0],
      dispatch: dispatch,
      render: render
    }) : forgeDoc.children.map(render)
  };
}
export var InlineDialog = function InlineDialog(props) {
  var _getInlineDialog = getInlineDialog(props),
    children = _getInlineDialog.children;
  return /*#__PURE__*/React.createElement(Fragment, null, children);
};